import React from "react"
import { IEnkAuthContextType } from "./auth-provider"
import AuthContext from "./auth-context"

export const useAuth = (): IEnkAuthContextType => {
  const context = React.useContext(AuthContext)

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider")
  }

  return context
}
